<template>
  <v-card outlined>
    <v-card-title class="subtitle-1 py-1 pl-2">
      <span class="pr-2">{{ scheduleItem.description }}</span>
    </v-card-title>
    <v-card-text>
      <v-row wrap>
        <v-col class="pb-0 pr-0 pl-1" cols="2">
          <DisplayField label="Units" :value="scheduleItem.numberOfUnits" type="number" />
        </v-col>
        <v-col class="pb-0 px-0" cols="4">
          <DisplayField label="Unit Price" :value="scheduleItem.unitPrice" type="currency" />
        </v-col>
        <v-col class="pb-0 px-0" cols="4">
          <DisplayField label="Value" :value="scheduleItem.value" type="currency" />
        </v-col>
        <v-col class="pb-0 px-0" cols="2">
          <DisplayField label="EXCLD" :value="scheduleItem.excluded ? 'Yes' : 'No'" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style>
</style>

<script>
import DisplayField from '@/components/Shared/DisplayField.vue';

export default {
  name: 'UnscheduledItem',
  components: {
    DisplayField
  },
  props: {
    scheduleItem: {
      type: Object,
      required: true
    }
  }
};
</script>
